import React from "react";
import PropTypes from "prop-types";
import C from "../../constants";
import FileDropzone from "../files/FileDropzone";
import { mimeTypes } from '../../helpers/strings'; 
import { isMobile, isTablet, isIOS, isAndroid } from "react-device-detect";

import _ from 'lodash';
import strings from "../../resources/strings";
const uuidv4 = require("uuid/v4/");

const DRAG_DROP_FILE_LIMIT = 1;

class CaptureCamera extends React.Component {
    constructor(props) {
        super(props);
        this.cameraInput = React.createRef();
        this.takePicture = this.takePicture.bind(this);
        this.handleFileSelection = this.handleFileSelection.bind(this);
    }

    takePicture() {
        var event = new MouseEvent("click", { bubbles: true });
        this.cameraInput.current.dispatchEvent(event);
    }

    isJPEG(file) {
        const reader = new FileReader();
        // We just want to peek at the first two bytes...
        reader.readAsArrayBuffer(file.slice(0,2));
        return new Promise((resolve, reject) => {
            reader.onload = function(event) {
                let buffer = new Uint8Array(event.target.result);
                resolve(buffer[0] === 255 && buffer[1] === 216);
            }
            reader.onerror = (error) => {
                console.log(error)
                reject(error);
            };
        })
    }

    handleDeviceInput(evt, processPhoto) {
        console.debug("Number of files returned: " + evt.target.files.length);
        evt.preventDefault();
        console.debug("Preventing default event handling");
        if (evt.target.files.length === 0) {
            console.debug("File length is 0, returning");
            return;
        }
        
        console.debug("Start processing");
        this.context.store.dispatch({ type: C.START_LOADING });
        let file = evt.target.files[0];

        let self = this;
        this.isJPEG(file).then(function(result) {
            file.isJPEG = result;
            self.handleProcessPhoto(file, processPhoto);
        });

    }

    displayUserMessage(store, stringResource, displayTime = 5000) {
        store.dispatch({ type: C.DISPLAY_USER_MESSAGE, message: strings.getString(stringResource), textColor: "white", backgroundColor: "green" });
        setTimeout(() => {
            store.dispatch({ type: C.HIDE_USER_MESSAGE });
        }, displayTime);        
    }

    handleProcessPhoto(file, processPhoto) {
        let self = this;
        let storeInContext = this.context.store;
        file.uuid = uuidv4();

        storeInContext.dispatch({ type: C.DISPLAY_USER_MESSAGE, message: strings.getString("mediaCaptured"), textColor: "white", backgroundColor: "green" });
        setTimeout(() => {
            storeInContext.dispatch({ type: C.HIDE_USER_MESSAGE });
        }, 5000);

        // In the case where the file is not a jpeg, say a png, but it has a jpg filename extension
        // then 
        if (_.includes(mimeTypes.IMAGE, file.type)) {
            if (file.isJPEG) {
                processPhoto(file, true, false, this.props.option).then(() => { // will only execute image analysis if needed
                    setTimeout(function() {
                        storeInContext.dispatch({ type: C.NEXT_QUESTION });
                        storeInContext.dispatch({ type: C.STOP_LOADING }); // loading started in CaptureCamera/CaptureAudio    
                        self.displayUserMessage(storeInContext, "mediaCaptured");
                        console.debug("Process photo complete");
                    }, 500);
                });
            }
            else {
                // handle files which may have a jpg extension in the filename but are not actually jpg's
                processPhoto(file, true, true, this.props.option).then(() => {
                    setTimeout(function() {
                        storeInContext.dispatch({ type: C.NEXT_QUESTION });
                        storeInContext.dispatch({ type: C.STOP_LOADING }); // loading started in CaptureCamera/CaptureAudio    
                        self.displayUserMessage(storeInContext, "mediaCaptured");
                        console.debug("Process photo complete");
                    }, 500);
                })    
            }
        }
        else if (_.includes(mimeTypes.FILES, file.type)) {
            processPhoto(file, true, true, this.props.option).then(() => {
                // There's a logic bug!!
                // processDeviceInput will either do weber/pop OR advance to the next question  
                // Here we want to do both... So we need to advance separately.
                setTimeout(function() {
                    storeInContext.dispatch({ type: C.NEXT_QUESTION });
                    storeInContext.dispatch({ type: C.STOP_LOADING }); // loading started in CaptureCamera/CaptureAudio
                    self.displayUserMessage(storeInContext, "mediaCaptured");
                    console.debug("Process photo complete");
                }, 500);
            })
        }
        else { // handle video here
            processPhoto(file, false, true, this.props.option).then(() => {
                setTimeout(function() {
                    storeInContext.dispatch({ type: C.NEXT_QUESTION });
                    storeInContext.dispatch({ type: C.STOP_LOADING }); // loading started in CaptureCamera/CaptureAudio
                    self.displayUserMessage(storeInContext, "mediaCaptured");
                    console.debug("Process photo complete");
                });
            });
        }        
    }

    handleFileSelection(filesArr) {
        if (_.isEmpty(filesArr)){
            return;
        }

        let store = this.context.store;

        // On development and staging do not enforce the limit check so that the automated UI tests can run.
        // Because of the way selenium and the dropzone control work, it constantly appends files, it will make
        // this error be returned whenever you try to drop a second file in a workflow in the automated UI tests.
        if (process.env.REACT_APP_ENVIRONMENT !== "development" && process.env.REACT_APP_ENVIRONMENT !== "staging"
                && filesArr && filesArr.length > DRAG_DROP_FILE_LIMIT)
        {
            store.dispatch({ type: C.DISPLAY_USER_MESSAGE, message: strings.getString("tooManyInputFiles"), textColor: "white", backgroundColor: "red" });
            setTimeout(() => {
                store.dispatch({ type: C.HIDE_USER_MESSAGE });
            }, 5000);
            return;
        }

        const file = filesArr[0]; //Only allowing 1 file selection at the moment.
        store.dispatch({ type: C.START_LOADING });

        let self = this;
        this.isJPEG(file).then(function(result) {
            file.isJPEG = result;
            self.handleProcessPhoto(file, self.props.processPhoto);
        });
    }

    render() {
        const inputStyle = { display: "none" };
        const isDesktopDevice = !isIOS && !isAndroid && !isMobile && !isTablet;

        let acceptTypes, captureAttr;
        switch(this.props.cameraType) {
            case "videoCamera":
                acceptTypes = isIOS || isDesktopDevice ? _.join(mimeTypes.VIDEO, ",") : "video/*";
                captureAttr = isIOS ? "environment" : "camcorder";
                break;
            case "allCameras":
                acceptTypes = isIOS || isDesktopDevice ? _.join([...mimeTypes.IMAGE, ...mimeTypes.VIDEO], ",") : "image/*,video/*";
                captureAttr = isIOS ? "environment" : "camcorder";
                if (!isIOS) {
                    captureAttr = ""; // this will prompt on Android
                }
                break;
            case "audioRecorder":
                acceptTypes = isIOS ? _.join(mimeTypes.VIDEO, ",") : "audio/*"; // iOS does not have an audio record so must use video
                if (!isIOS) {
                    captureAttr = "microphone";
                }
                break;
            case "anyInput":
                acceptTypes = "";
                break;
            case "camera":
            default:
                acceptTypes = isIOS || isDesktopDevice ? _.join(mimeTypes.IMAGE, ",") : "image/*";
                if (_.has(this.props.option, "acceptTypes")) {
                    for (let i = 0; i < this.props.option.acceptTypes.length; i++) {
                        acceptTypes += "," + this.props.option.acceptTypes[i];
                    }
                }
                
                if (this.props.captureAttr) {
                    captureAttr = this.props.captureAttr;
                }
                if (this.props.option.cameraSpecifier) {
                    captureAttr = this.props.option.cameraSpecifier;
                }
                if (!isIOS) {
                    captureAttr = "camera";
                    if (this.props.captureAttr === "photoLibrary" || this.props.option.cameraSpecifier === "photoLibrary") {
                        captureAttr = "photoLibrary";
                    }
                }
                break;
        }

        // Add PDFs to the accepted files on desktop
        if (isDesktopDevice && (this.props.cameraType === "camera" || this.props.cameraType === "allCameras")) {
            acceptTypes += ",application/pdf";
        }

        let inputTag, dummyTag, dummyButton;
        if (captureAttr === "photoLibrary") {
            if (isAndroid) {
                inputTag = (
                    <input type="file" ref={this.cameraInput} accept={acceptTypes} style={inputStyle}
                        onChange={evt => {
                            this.handleDeviceInput(evt, this.props.processPhoto); 
                        }}
                    />
                );
                dummyTag = (
                    <input type="file" ref={this.cameraInput} accept={acceptTypes} id="capture2" style={inputStyle} onChange={evt => {this.handleDeviceInput(evt, this.props.processPhoto);}}/>
                );
                dummyButton = (
                    <button
                        style={inputStyle}
                        className="w3-button w3-block w3-indigo w3-round-xxlarge w3-large"
                        onClick={() => {
                            this.takePicture();
                        }}
                    >
                        Test 1
                    </button>
                );
            }
            else { // iOS
                inputTag = (
                    <input type="file" ref={this.cameraInput} accept={acceptTypes} id="capture" style={inputStyle}
                        onChange={evt => {
                            this.handleDeviceInput(evt, this.props.processPhoto); 
                        }}
                    />
                );
            }
        }
        else if (isDesktopDevice) {
            inputTag = (
                    <input type="file" ref={this.cameraInput} accept={acceptTypes} capture id="capture" style={inputStyle}
                        onChange={evt => {
                            this.handleDeviceInput(evt, this.props.processPhoto); 
                        }}
                    />
            );
        }
        else {
            inputTag = (
                    <input type="file" ref={this.cameraInput} accept={acceptTypes} capture={captureAttr} id="capture" style={inputStyle}
                        onChange={evt => {
                            this.handleDeviceInput(evt, this.props.processPhoto); 
                        }}
                    />
            );
        }

        let buttonClasses = "w3-button w3-block w3-round-xxlarge w3-large";
        buttonClasses += " " + _.get(this, "props.option.buttonColorClass", "w3-indigo");

        return (
            isDesktopDevice ?
            <FileDropzone handleSelection={this.handleFileSelection} accept={acceptTypes} {...this.props}/>
            :
            <div>
                {inputTag}
                <button
                    className={buttonClasses}
                    onClick={() => {
                        this.takePicture();
                    }}
                >
                    {this.props.label}
                </button>

                {dummyTag}
                {dummyButton}
            </div>
        );
    }
}

CaptureCamera.propTypes = {
    store: PropTypes.object,
    processPhoto: PropTypes.func
};

CaptureCamera.contextTypes = {
    store: PropTypes.object,
};

export default CaptureCamera;
